//#region IMPORT
import { useState, useEffect, useRef } from 'react';
import TRA_NEW_04 from './TRA_NEW_04';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import useActionLog from '../../../../../hooks/useActionLog';
import {
  closeLoading,
  showLoading,
} from '../../../../../Reducer/LoadingReducer';
import { Typography, Checkbox, FormControlLabel } from '@mui/material';
import {
  useDelete1,
  useDelete2,
  useSave1,
  useSave2,
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
} from './TRA_NEW_04_QUERY';
import useFileUpload from '../../../../../hooks/useFileUpload';
import HwpPreview from '../../../../../Components/FilePreview/HwpPreview';

//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'MultiTrainingPage';

function TRA_NEW_04F(props) {
  // 파일 업로드 부분등 수정이 더 필요할 것으로 예상됨
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  //로그 관련
  const { SaveActionLog } = useActionLog();

  // 교육자료 등록 그리드
  const [rowData1, setRowData1] = useState([]); // 교육자료 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육자료 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육자료 그리드 변경 시 데이터

  // 그리드 행 별 파일 업로드팝업
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalType, setModalType] = useState('edu'); // 'edu' 또는 'video'
  const [fileList, setFileList] = useState([]); // 기본정보 테이블용 파일 목록

  // 추가 버튼클릭 시 파일 업로드팝업 - 부서고르는 팝업
  const [modalToggle2, setModalToggle2] = useState(false);

  // 추가 버튼클릭 시 부서고르는 팝업에서 자료등록하는 모달
  const [modalToggle3, setModalToggle3] = useState(false);
  const [tempFileList3, setTempFileList3] = useState([]); // modalToggle3용 임시 파일 리스트
  const [tempPreviewVideoUrl, setTempPreviewVideoUrl] = useState(null); // modalToggle3용 동영상 미리보기 URL

  // 파일 삭제 확인 다이얼로그
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [pendingDeleteFile, setPendingDeleteFile] = useState(null);

  const rowClickData = useRef(null);

  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewFileName, setPreviewFileName] = useState('');

  const fileInputRef = useRef(null);
  const prevFilePathRef = useRef();
  const prevVideoPathRef = useRef('');

  const [videoFile, setVideoFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoFileName, setVideoFileName] = useState('');

  const [departmentList, setDepartmentList] = useState([]); // 전체 부서 데이터
  const [selectedBonbu, setSelectedBonbu] = useState([]);
  const [selectedBuseo, setSelectedBuseo] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [selectedPart, setSelectedPart] = useState([]);

  const [bonbuList, setBonbuList] = useState([]);
  const [buseoList, setBuseoList] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [partList, setPartList] = useState([]);

  const {
    SaveLogicPreview: SaveLogicPreview1,
    SaveLogicFile: SaveLogicFile1,
    DeleteLogicFile: DeleteLogicFile1,
  } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (item) =>
      `Education/${searchInfo.custCd}/${item.depCd}/DEP_BASIC`,
  });

  const {
    SaveLogicPreview: SaveLogicPreview2,
    SaveLogicFile: SaveLogicFile2,
    DeleteLogicFile: DeleteLogicFile2,
  } = useFileUpload({
    oldFilePathField: 'filePath',
    newFileNameField: 'saveName',
    getTargetPath: (item) =>
      `Video/${searchInfo.custCd}/${item.depCd}/DEP_BASIC`,
  });

  useEffect(() => {
    const bonbuSet = new Set(
      departmentList
        .map((dep) => {
          return dep.depNm1;
        })
        .filter(Boolean)
    );

    const bonbus = Array.from(bonbuSet);
    setBonbuList(bonbus);
  }, [departmentList]);

  useEffect(() => {
    if (selectedBonbu.length === 0) {
      setBuseoList([]);
      setSelectedBuseo([]);
      setTeamList([]);
      setSelectedTeam([]);
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const buseoSet = new Set(
      departmentList
        .filter((dep) => selectedBonbu.includes(dep.depNm1))
        .map((dep) => dep.depNm2)
        .filter(Boolean)
    );
    setBuseoList(Array.from(buseoSet));

    // 하위 초기화
    setSelectedBuseo([]);
    setTeamList([]);
    setSelectedTeam([]);
    setPartList([]);
    setSelectedPart([]);
  }, [selectedBonbu, departmentList]);

  // 부서 선택 바뀌면 팀 목록 업데이트, 하위 초기화
  useEffect(() => {
    if (selectedBuseo.length === 0) {
      setTeamList([]);
      setSelectedTeam([]);
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const teamSet = new Set(
      departmentList
        .filter((dep) => selectedBuseo.includes(dep.depNm2))
        .map((dep) => dep.depNm3)
        .filter(Boolean)
    );
    setTeamList(Array.from(teamSet));

    setSelectedTeam([]);
    setPartList([]);
    setSelectedPart([]);
  }, [selectedBuseo, departmentList]);

  // 팀 선택 바뀌면 파트 목록 업데이트, 하위 초기화
  useEffect(() => {
    if (selectedTeam.length === 0) {
      setPartList([]);
      setSelectedPart([]);
      return;
    }

    const partSet = new Set(
      departmentList
        .filter((dep) => selectedTeam.includes(dep.depNm3))
        .map((dep) => dep.depNm4)
        .filter(Boolean)
    );
    setPartList(Array.from(partSet));

    setSelectedPart([]);
  }, [selectedTeam, departmentList]);

  // 체크박스 토글 함수 (다중 선택)
  const toggleSelection = (value, selectedList, setSelectedList) => {
    if (selectedList.includes(value)) {
      const updated = selectedList.filter((v) => v !== value);
      setSelectedList(updated);
    } else {
      setSelectedList([...selectedList, value]);
    }
  };

  // 렌더링 체크박스 목록
  const renderCheckboxList = (list = [], selectedList = [], onChange) => {
    if (!Array.isArray(list) || list.length === 0) {
      return (
        <Typography variant="body2" sx={{ p: 1, color: 'gray' }}>
          선택 가능한 항목이 없습니다.
        </Typography>
      );
    }

    return list.map((item) => (
      <FormControlLabel
        key={item}
        control={
          <Checkbox
            checked={selectedList.includes(item)}
            onChange={() => onChange(item)}
          />
        }
        label={item}
      />
    ));
  };

  // 전체본부 리스트 조회
  const { refetch: fetchDepartmentData } = useSearch3({
    onSuccess: async (rows) => {
      setDepartmentList(rows);
    },
  });

  // 최종선택된 depCd 추출
  // 선택된 부서명에 해당하는 모든 depCd를 조회
  // 예: '민들레1' 선택 시 → depNm1이 '민들레1'인 모든 depCd 반환
  // 예: '라벤더' 선택 시 → depNm2가 '라벤더'인 모든 depCd 반환
  const getExportDepCds = () => {
    const finalItems = getFilteredSelectedItems(); // Chip에 보여지는 최종 선택된 부서명 목록
    const depCds = new Set();

    for (const item of finalItems) {
      // depNm4 (파트)부터 확인하여 가장 하위 레벨부터 매칭
      if (departmentList.some((dep) => dep.depNm4 === item)) {
        // depNm4가 일치하는 모든 depCd 수집
        departmentList
          .filter((dep) => dep.depNm4 === item)
          .forEach((dep) => {
            depCds.add(dep.depCd);
            console.log(`depNm4 "${item}" 매칭 → depCd: ${dep.depCd}`);
          });
      } else if (departmentList.some((dep) => dep.depNm3 === item)) {
        // depNm3가 일치하는 모든 depCd 수집
        departmentList
          .filter((dep) => dep.depNm3 === item)
          .forEach((dep) => {
            depCds.add(dep.depCd);
            console.log(`depNm3 "${item}" 매칭 → depCd: ${dep.depCd}`);
          });
      } else if (departmentList.some((dep) => dep.depNm2 === item)) {
        // depNm2가 일치하는 모든 depCd 수집 (예: '라벤더')
        departmentList
          .filter((dep) => dep.depNm2 === item)
          .forEach((dep) => {
            depCds.add(dep.depCd);
            console.log(`depNm2 "${item}" 매칭 → depCd: ${dep.depCd}`);
          });
      } else if (departmentList.some((dep) => dep.depNm1 === item)) {
        // depNm1이 일치하는 모든 depCd 수집 (예: '민들레1')
        departmentList
          .filter((dep) => dep.depNm1 === item)
          .forEach((dep) => {
            depCds.add(dep.depCd);
            console.log(`depNm1 "${item}" 매칭 → depCd: ${dep.depCd}`);
          });
      }
    }

    return Array.from(depCds);
  };
  const getDepLevel = (item) => {
    if (departmentList.some((dep) => dep.depNm4 === item)) return '파트';
    if (departmentList.some((dep) => dep.depNm3 === item)) return '팀';
    if (departmentList.some((dep) => dep.depNm2 === item)) return '부서';
    if (departmentList.some((dep) => dep.depNm1 === item)) return '본부';
    return '';
  };

  // 중첩 필터링 함수
  const getFilteredSelectedItems = () => {
    const selectedItems = [];

    // Part 선택 항목은 항상 우선순위 가장 높음
    selectedPart.forEach((part) => selectedItems.push(part));

    // Team에서 Part에 포함되지 않은 것만 추가
    selectedTeam.forEach((team) => {
      const hasPart = departmentList.some(
        (dep) => dep.depNm3 === team && selectedPart.includes(dep.depNm4)
      );
      if (!hasPart) selectedItems.push(team);
    });

    // Buseo에서 Team이나 Part에 포함되지 않은 것만 추가
    selectedBuseo.forEach((buseo) => {
      const hasTeamOrPart = departmentList.some(
        (dep) =>
          dep.depNm2 === buseo &&
          (selectedTeam.includes(dep.depNm3) ||
            selectedPart.includes(dep.depNm4))
      );
      if (!hasTeamOrPart) selectedItems.push(buseo);
    });

    // Bonbu에서 Buseo/Team/Part에 포함되지 않은 것만 추가
    selectedBonbu.forEach((bonbu) => {
      const hasDescendant = departmentList.some(
        (dep) =>
          dep.depNm1 === bonbu &&
          (selectedBuseo.includes(dep.depNm2) ||
            selectedTeam.includes(dep.depNm3) ||
            selectedPart.includes(dep.depNm4))
      );
      if (!hasDescendant) selectedItems.push(bonbu);
    });

    return selectedItems;
  };

  // 최종선택한 부서의 하위부서 전체 저장 로직
  const handleSave = async () => {
    // 선택된 부서명에 해당하는 모든 depCd 조회
    // 예: '민들레1' 선택 시 → depNm1이 '민들레1'인 모든 depCd
    // 예: '라벤더' 선택 시 → depNm2가 '라벤더'인 모든 depCd
    const depCdList = getExportDepCds();

    if (!depCdList.length) {
      dispatch(
        showSnackbar({ message: '대상 부서를 선택해주세요.', type: 'warning' })
      );
      return;
    }

    // tempFileList3에 파일이 있는지 확인
    if (!tempFileList3 || tempFileList3.length === 0) {
      dispatch(
        showSnackbar({
          message: '저장할 파일이 없습니다. 파일을 업로드해주세요.',
          type: 'warning',
        })
      );
      return;
    }

    // 로딩중 띄우기
    dispatch(showLoading());

    try {
      // tempFileList3에서 교육자료와 동영상 분리
      const eduFiles = tempFileList3.filter((f) => f.type === 'edu');
      const videoFiles = tempFileList3.filter((f) => f.type === 'video');

      // 조회된 모든 depCd에 대해 파일 저장
      for (const depCd of depCdList) {
        // 교육자료 파일들 저장
        for (const eduFileItem of eduFiles) {
          if (!eduFileItem.file) continue;

          //DB저장용 경로(파일name포함)
          const eduPath = `Education/${searchInfo.custCd}/${depCd}/DEP_BASIC/${eduFileItem.fileName}`;

          //서버저장용 경로(파일name빼고)
          const eduPathServer = `Education/${searchInfo.custCd}/${depCd}/DEP_BASIC`;

          // 파일서버에 교육자료 업로드
          await SaveLogic3(eduPathServer, eduFileItem.file, null);

          await Save2Async({
            rows: [
              { depCd, fileName: eduFileItem.fileName, filePath: eduPath },
            ],
          });

          // DB 저장 호출 (교육자료만 - SP_TRA_NEW_04_U2 사용)
          // await saveEduFileToDB(depCd, eduFileItem.fileName, eduPath);
        }

        // 동영상 파일들 저장
        for (const videoFileItem of videoFiles) {
          if (!videoFileItem.file) continue;

          //DB저장용 경로(파일name포함)
          const videoPath = `Video/${searchInfo.custCd}/${depCd}/DEP_BASIC/${videoFileItem.fileName}`;

          //서버저장용 경로(파일name빼고)
          const videoPathServer = `Video/${searchInfo.custCd}/${depCd}/DEP_BASIC`;

          // 파일서버에 동영상 업로드
          await SaveLogic2(videoPathServer, videoFileItem.file, null);

          // DB 저장 호출 (동영상만 - SP_TRA_NEW_04_U1 사용)
          await Save1Async({
            rows: [
              { depCd, fileName: videoFileItem.fileName, filePath: videoPath },
            ],
          });
        }
      }

      dispatch(
        showSnackbar({ message: '저장 및 업로드 완료.', type: 'success' })
      );

      setModalToggle2(false); //모달닫기
      setModalToggle3(false); // modalToggle3도 닫기

      // tempFileList3 초기화
      setTempFileList3([]);
      setTempPreviewVideoUrl(null);
      setPreviewUrl('');
      setPreviewFileName('');

      // 정상 완료 시 로그
      await SaveActionLog([...depCdList], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'SUCCESS',
      });

      await Search1(); //그리드 재조회
    } catch (error) {
      // 오류 시 로그
      await SaveActionLog([...depCdList], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: error.message,
      });

      console.error('저장 중 오류 발생:', error);
      dispatch(
        showSnackbar({
          message: error.message || '저장 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      // 로딩 종료
      dispatch(closeLoading());
    }
  };
  // 동영상만 DB에 저장 (SP_TRA_NEW_04_U1 사용)
  const { runAsync: Save1Async } = useSave1();

  // 교육자료만 DB에 저장 (SP_TRA_NEW_04_U2 사용)
  const { runAsync: Save2Async } = useSave2();

  // 그리드 행별 비디오파일 업로드 시(그리드 업로드 버튼 클릭 시 팝업)
  const handleVideoChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('video/')) return;

    const depCd = rowClickData.current?.depCd;

    const previewFilePath = await SaveLogicPreview2(file);
    if (!previewFilePath) return;

    await SaveLogicFile2(
      {
        depCd,
        filePath: '',
        saveName: file.name,
        previewFilePath,
      },
      searchInfo.custCd
    );

    const videoPath = `Video/${searchInfo.custCd}/${depCd}/DEP_BASIC/${file.name}`;
    await Save1Async({
      rows: [{ depCd, fileName: file.name, filePath: videoPath }],
    });

    await loadFileList(depCd, 'video');
  };

  // 그리드 행별 교육파일 업로드 시(그리드 업로드 버튼 클릭 시 팝업)
  const handleEduFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const depCd = rowClickData.current?.depCd;

    const previewFilePath = await SaveLogicPreview1(file);
    if (!previewFilePath) return;

    await SaveLogicFile1(
      {
        depCd,
        filePath: '',
        saveName: file.name,
        previewFilePath,
      },
      searchInfo.custCd
    );

    const eduPath = `Education/${searchInfo.custCd}/${depCd}/DEP_BASIC/${file.name}`;
    await Save2Async({
      rows: [{ depCd, fileName: file.name, filePath: eduPath }],
    });

    await loadFileList(depCd, 'edu');
  };

  //#endregion
  // 팝업 오픈시 초기 파일 정보 불러오기 ( 동영상, 교육자료 )

  const loadInitialFile = async (depCd, type = 'edu') => {
    if (type === 'edu') {
      await Search2({ depCd: depCd }); // 교육자료
    } else {
      await Search4({ depCd: depCd }); // 동영상
    }
  };
  // 파일 목록 불러오기 (기본정보 테이블용)

  const loadFileList = async (depCd, type = 'edu') => {
    if (type === 'edu') {
      await Search2({ depCd: depCd });
    } else {
      await Search4({ depCd: depCd });
    }
  };

  const getFullFileUrl = (relativePath) => {
    if (!relativePath) return '';
    const fixedPath = fixUrl(relativePath);
    const fullUrl = `${Global.file.useUrl}files/${fixedPath}`;
    return fullUrl;
  };

  // 기본정보 그리드에서 파일 행 클릭 시 미리보기 업데이트
  const handleFileRowClick = (fileRow) => {
    if (!fileRow || !fileRow.filePath) return;

    // 파일 타입 판단: modalType 상태를 우선 사용, 없으면 파일 경로로 판단
    let currentType = modalType;

    // modalType이 없거나 불확실한 경우 파일 경로로 판단
    if (!currentType || currentType === 'edu') {
      if (
        fileRow.filePath?.includes('Video') ||
        fileRow.filePath?.includes('video')
      ) {
        currentType = 'video';
      }
    }

    if (currentType === 'edu') {
      // 교육자료 미리보기 업데이트
      const filePath = fileRow.filePath;
      const fileName = fileRow.fileName;

      // 파일 확장자 확인
      const ext = fileName.split('.').pop()?.toLowerCase() || '';

      // PDF로 변환 가능한 파일 형식 확인 (한글은 원본을 rhwp 뷰어로 렌더링하므로 제외)
      const convertibleExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

      // PDF로 변환 가능한 파일인 경우 PDF 파일 경로로 변경
      let previewFilePath = filePath;
      if (convertibleExts.includes(ext)) {
        // 원본 파일 경로에서 확장자를 PDF로 변경
        previewFilePath = filePath.replace(
          /\.(doc|docx|ppt|pptx|xls|xlsx)$/i,
          '.pdf'
        );
      }

      prevFilePathRef.current = filePath; // 원본 파일 경로 저장
      setPreviewFileName(fileName);
      setPreviewUrl(fixUrl(previewFilePath)); // PDF 파일 경로 또는 원본 경로
    } else {
      // 동영상 미리보기 업데이트
      const videoFullUrl = getFullFileUrl(fileRow.filePath);
      prevVideoPathRef.current = fileRow.filePath;
      setVideoUrl(videoFullUrl);
      setVideoFileName(fileRow.fileName);
      setVideoFile(null); // 로컬 파일 초기화
    }
  };

  // 파일 리스트에서 특정 파일 삭제 확인 다이얼로그 열기
  const handleFileListDelete = (fileRow) => {
    if (!fileRow || !fileRow.filePath) {
      dispatch(
        showSnackbar({
          message: '삭제할 파일 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!fileRow.fileId) {
      dispatch(
        showSnackbar({
          message: '파일 ID가 없어 삭제할 수 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    // 삭제 확인 다이얼로그 열기
    setPendingDeleteFile(fileRow);
    setDeleteConfirmOpen(true);
  };

  const delete1 = useDelete1();
  const delete2 = useDelete2();

  // 파일 삭제 확인 후 실제 삭제 실행
  const handleFileListDeleteConfirm = async () => {
    if (!pendingDeleteFile) return;

    const fileRow = pendingDeleteFile;
    setDeleteConfirmOpen(false);

    try {
      dispatch(showLoading());

      let currentType = modalType;
      if (!currentType || currentType === 'edu') {
        if (
          fileRow.filePath?.includes('Video') ||
          fileRow.filePath?.includes('video')
        ) {
          currentType = 'video';
        }
      }

      const deleted =
        currentType === 'video'
          ? await DeleteLogicFile2(fileRow.filePath)
          : await DeleteLogicFile1(fileRow.filePath);

      if (!deleted) {
        dispatch(
          showSnackbar({ message: '파일 삭제에 실패했습니다.', type: 'error' })
        );
        return;
      }

      if (currentType === 'edu') {
        await delete1.runAsync([{ fileId: fileRow.fileId }]);
      } else {
        await delete2.runAsync([{ fileId: fileRow.fileId }]);
      }

      const depCd = rowClickData.current?.depCd;
      await loadFileList(depCd, currentType === 'edu' ? 'edu' : 'video');
      await loadInitialFile(depCd, currentType === 'edu' ? 'edu' : 'video');

      if (currentType === 'edu') {
        if (prevFilePathRef.current === fileRow.filePath) {
          setPreviewFileName('');
          setPreviewUrl('');
          prevFilePathRef.current = '';
        }
      } else {
        if (prevVideoPathRef.current === fileRow.filePath) {
          setVideoUrl(null);
          setVideoFileName('');
          prevVideoPathRef.current = '';
        }
      }

      dispatch(
        showSnackbar({ message: '파일이 삭제되었습니다.', type: 'success' })
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error.message || '파일 삭제 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
      setPendingDeleteFile(null);
    }
  };
  // URL 인코딩 처리
  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  //#region 조회
  //조회조건 부서 조회
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      setRowData1(rows);
    },
  });
  const { run: Search2 } = useSearch2({
    onSuccess: (rows) => {
      const fileListData = [];

      // 여러 건의 데이터를 모두 처리
      rows.forEach((item, index) => {
        const eduPath = item.eduLocation || '';
        if (eduPath) {
          const fileName = eduPath.split('/').pop();
          const regDate =
            item.eduRegDate ||
            item.createDate ||
            item.updateDate ||
            new Date().toISOString().split('T')[0];
          fileListData.push({
            no: index + 1,
            fileName: fileName,
            regDate: regDate,
            filePath: eduPath,
            fileId: item.eduFileId || null, // 파일 ID 추가
          });
        }
      });

      setFileList(fileListData);

      // 첫 번째 파일을 미리보기용으로 설정
      if (fileListData.length > 0) {
        const firstFile = fileListData[0];
        const eduFixedUrl = fixUrl(firstFile.filePath);
        prevFilePathRef.current = firstFile.filePath;
        setPreviewFileName(firstFile.fileName);
        setPreviewUrl(eduFixedUrl);
      }
    },
  });
  // 동영상 탭 클릭 시 파일 목록 조회 (loadInitialFile과 동일한 구조)
  const { run: Search4 } = useSearch4({
    onSuccess: (rows) => {
      const fileListData = [];

      // 여러 건의 데이터를 모두 처리
      rows.forEach((item, index) => {
        const videoPath = item.videoLocation || '';
        if (videoPath) {
          const fileName = videoPath.split('/').pop();
          const regDate =
            item.videoRegDate ||
            item.createDate ||
            item.updateDate ||
            new Date().toISOString().split('T')[0];
          fileListData.push({
            no: index + 1,
            fileName: fileName,
            regDate: regDate,
            filePath: videoPath,
            fileId: item.eduVideoId || null, // 파일 ID 추가 (EDU_VIDEO_ID 우선)
          });
        }
      });
      setFileList(fileListData);
      // 첫 번째 파일을 미리보기용으로 설정
      if (fileListData.length > 0) {
        const firstFile = fileListData[0];
        const videoFullUrl = getFullFileUrl(firstFile.filePath);
        prevVideoPathRef.current = firstFile.filePath;
        setVideoUrl(videoFullUrl);
        setVideoFileName(firstFile.fileName);
      }
    },
  });

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    dispatch(showLoading());
    let headerData = [];
    let tableData = [];

    try {
      headerData.push({
        safetyYear: dayjs(searchInfo.searchYear).format('YYYY'),
      });
      tableData = rowData1;
      const printData = {
        FileName: 'TRA_NEW_04',
        TableData: JSON.stringify(tableData),
        HeaderData: JSON.stringify(headerData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const PopupClickEvent1 = async (e, type = 'edu') => {
    rowClickData.current = e;
    setModalType(type);

    //상태 초기화
    setVideoFile(null); // 비디오 파일
    setPreviewFileName(''); // 교육자료 파일명
    setPreviewUrl(''); // 교육자료 미리보기 URL
    setVideoUrl(null); // 비디오 URL
    setVideoFileName(''); // 비디오 파일명
    setFileList([]); // 파일 목록 초기화

    prevFilePathRef.current = ''; // 기존 파일 경로 참조값도 초기화
    prevVideoPathRef.current = '';

    await loadInitialFile(e.depCd, type);
    await loadFileList(e.depCd, type);
    //await SearchLogic2();
    setTimeout(() => setModalToggle1(true), 100);
  };

  const PopupClickEvent2 = async (e) => {
    setModalToggle3(true);

    setPreviewUrl('');
    setPreviewFileName('');

    // 교육동영상 상태 초기화
    setVideoFile(null);
    setVideoFileName('');
    setVideoUrl && setVideoUrl(''); // 서버에서 불러온 영상 경로도 있다면 초기화

    // modalToggle3용 임시 파일 리스트 초기화
    setTempFileList3([]);
    setTempPreviewVideoUrl(null);

    // 기타 필요 상태 초기화
    if (fileInputRef?.current) fileInputRef.current.value = '';
  };

  // modalToggle3용 교육자료 파일 선택 (리스트에만 추가, 저장 안 함)
  const handleEduFileChange3 = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      // 파일을 서버에 업로드하고 URL 받기 (저장은 나중에)
      const { path, url } = await uploadFileAndGetUrl2(file, 'edu');

      // 임시 파일 리스트에 추가
      const newFile = {
        id: Date.now() + Math.random(), // 고유 ID
        type: 'edu',
        fileName: file.name,
        filePath: path,
        fileUrl: url,
        file: file, // 원본 파일 객체
        regDate: new Date().toISOString().split('T')[0], // 오늘 날짜
      };

      setTempFileList3((prev) => [...prev, newFile]);

      // 첫 번째 파일이면 미리보기 설정
      if (url) {
        setPreviewUrl(url);
        setPreviewFileName(file.name);
      }

      dispatch(
        showSnackbar({
          message: `${file.name} 파일이 리스트에 추가되었습니다.`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `파일 업로드 실패: ${error.message}`,
          type: 'error',
        })
      );
      console.error('파일 업로드 실패:', error);
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  // modalToggle3용 동영상 파일 선택 (리스트에만 추가, 저장 안 함)
  const handleVideoChange3 = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      dispatch(
        showSnackbar({
          message: '비디오 파일만 업로드 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      // 파일을 서버에 업로드하고 URL 받기 (저장은 나중에)
      const { path, url } = await uploadFileAndGetUrl2(file, 'video');

      // 임시 파일 리스트에 추가
      const newFile = {
        id: Date.now() + Math.random(), // 고유 ID
        type: 'video',
        fileName: file.name,
        filePath: path,
        fileUrl: url,
        file: file, // 원본 파일 객체
        regDate: new Date().toISOString().split('T')[0], // 오늘 날짜
      };

      setTempFileList3((prev) => [...prev, newFile]);

      // 첫 번째 파일이면 미리보기 설정
      const src = getFullFileUrl(path || url);
      if (src) {
        setTempPreviewVideoUrl(src);
      }

      dispatch(
        showSnackbar({
          message: `${file.name} 파일이 리스트에 추가되었습니다.`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(
        showSnackbar({
          message: `파일 업로드 실패: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  // modalToggle3용 파일 리스트 행 클릭 (미리보기)
  const handleTempFileRowClick3 = (fileRow) => {
    if (!fileRow) return;

    if (fileRow.type === 'edu') {
      // 교육자료 미리보기
      if (fileRow.fileUrl) {
        setPreviewUrl(fileRow.fileUrl);
        setPreviewFileName(fileRow.fileName);
      }
    } else if (fileRow.type === 'video') {
      // 동영상 미리보기
      const src = getFullFileUrl(fileRow.fileUrl || fileRow.filePath);
      setTempPreviewVideoUrl(src);
    }
  };

  // modalToggle3용 파일 리스트에서 삭제
  const handleTempFileDelete3 = (fileRow) => {
    if (!fileRow) return;

    // 리스트에서 제거
    setTempFileList3((prev) => prev.filter((f) => f.id !== fileRow.id));

    // 삭제된 파일이 현재 미리보기 중인 파일이면 초기화
    if (fileRow.type === 'edu') {
      if (previewUrl === fileRow.fileUrl) {
        setPreviewUrl('');
        setPreviewFileName('');
      }
    } else if (fileRow.type === 'video') {
      if (tempPreviewVideoUrl === fileRow.fileUrl) {
        setTempPreviewVideoUrl(null);
      }
    }

    dispatch(
      showSnackbar({
        message: `${fileRow.fileName} 파일이 리스트에서 제거되었습니다.`,
        type: 'info',
      })
    );
  };

  // 파일 확장자 추출 헬퍼
  const getExtension = (url) => {
    if (!url) return '';
    const name = url.split('/').pop();
    return name?.split('.').pop().toLowerCase() || '';
  };

  // 서버에 파일 업로드 후 URL 얻기
  const uploadFileAndGetUrl2 = async (file, type) => {
    const previewPathOrUrl =
      type === 'edu'
        ? await SaveLogicPreview1(file)
        : await SaveLogicPreview2(file);

    if (!previewPathOrUrl) return { path: '', url: '' };

    return { path: previewPathOrUrl, url: previewPathOrUrl };
  };

  // 동영상파일 파일서버에 저장
  const SaveLogic2 = async (_value1, _value2, oldFullPath) => {
    // 기존파일 삭제
    try {
      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '동영상파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 교육자료파일 파일서버에 저장
  const SaveLogic3 = async (_value1, _value2, oldFullPath) => {
    try {
      const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
      let finalSavePath = '';

      // ✅ 대용량 파일: 청크 업로드
      if (_value2.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_value1, _value2);
      }
      // ✅ 일반 파일 업로드
      else {
        const formData = new FormData();

        formData.append('UserId', userInfo.userid);
        formData.append('FilePath', _value1);
        formData.append('FormFile', _value2);

        const res = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formData
        );

        finalSavePath = res?.data?.filePath || '';
      }

      if (!finalSavePath) {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }

      const savePath = finalSavePath.replace(/\\/g, '/');

      // PDF로 변환 가능한 파일 형식 확인 및 변환 ( moveAndReplaceFile 함수를 사용할 경우 옮기는 과정에서 파일이 깨짐. 폴더에 직접변환처리)
      const ext = _value2.name.split('.').pop()?.toLowerCase();
      const convertibleExts = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];

      if (convertibleExts.includes(ext)) {
        const convertedUrl = await ConvertFileToPdf(savePath); // 실제 저장된 위치에서 변환!!!

        if (!convertedUrl) {
          dispatch(
            showSnackbar({
              message: `${ext.toUpperCase()} → PDF 변환 실패`,
              type: 'error',
            })
          );
          return savePath;
        }

        // 성공 시 PDF도 저장되었음
        // dispatch(showSnackbar({ message: 'PDF 변환 완료', type: 'success' }));
      }

      return savePath;
    } catch (e) {
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
      throw e; // ✅ 에러를 상위로 전파
    } finally {
    }
  };

  // 미리보기 렌더 함수 (previewUrl 기반) - SAM_BASIC_01F.js의 PreviewRender 참고
  const renderPreview = () => {
    if (!previewUrl) return <div>미리보기 영역</div>;

    // previewUrl에서 파일명 추출하여 확장자 확인
    const fileName = previewUrl.split('/').pop() || previewUrl;
    const ext = fileName.split('.').pop()?.toLowerCase() || '';
    const fullUrl = Global.file.useUrl + 'files/' + previewUrl;

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    if (['hwp', 'hwpx'].includes(ext)) {
      return (
        <HwpPreview
          filePath={previewUrl}
          fileName={previewFileName || fileName}
          height="600px"
        />
      );
    }

    if (['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
      // previewUrl이 이미 PDF URL일 수 있으므로, 확장자가 pdf가 아니면 PDF 확장자로 변경
      const pdfUrl =
        ext !== 'pdf'
          ? fullUrl.replace(/\.(doc|docx|ppt|pptx|xls|xlsx)$/i, '.pdf')
          : fullUrl;

      return (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          title="PDF 미리보기"
          allow="fullscreen"
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const uploadInChunks = async (
    filePath,
    file,
    chunkSize = 5 * 1024 * 1024
  ) => {
    const totalChunks = Math.ceil(file.size / chunkSize);
    const saveName = file.name;

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkIndex', i);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', saveName);
      formData.append('UserId', userInfo.userid);
      formData.append('FilePath', filePath);

      await Commons.Axios(
        'chunk',
        Global.file.useUrl + Global.urls.Execute.UploadChunk,
        null,
        formData
      );
    }

    // 병합 요청
    const mergeResponse = await Commons.Axios(
      'post',
      Global.file.useUrl + Global.urls.Execute.MergeChunks,
      null, // 쿼리스트링 없음
      {
        fileName: saveName,
        filePath,
        userId: userInfo.userid,
      }
    );

    return mergeResponse?.data?.filePath || '';
  };

  // 파일 확장자에 따른 PDF 변환 함수 (HWP, Office 파일 모두 변환) - SAM_BASIC_01F.js 참고
  const ConvertFileToPdf = async (_filePath) => {
    if (!_filePath) {
      console.error('ConvertFileToPdf: filePath가 없습니다.');
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      // 파일 경로에서 확장자 추출
      const fileName =
        _filePath.split('/').pop() || _filePath.split('\\').pop();
      const ext = fileName.split('.').pop()?.toLowerCase();

      // 확장자에 따라 다른 변환 API 선택
      let convertApiUrl = '';
      switch (ext) {
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
          convertApiUrl = Global.urls.Execute.ConvertOfficeToPdf;
          break;
        default:
          console.error(
            `ConvertFileToPdf: 지원하지 않는 파일 형식입니다: ${ext}`
          );
          return null;
      }

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + convertApiUrl,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
        // 서버가 '/PreviewFiles/xxx.pdf' 형태로 반환하면 'files/PreviewFiles/xxx.pdf'
      } else {
        console.error('ConvertFileToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.error('ConvertFileToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };

  // 파일 리스트에서 파일 다운로드 (modalToggle1용)
  const handleFileListDownload = async (fileRow) => {
    if (!fileRow || !fileRow.filePath) {
      dispatch(
        showSnackbar({
          message: '다운로드할 파일 정보가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    try {
      const fileUrl = fileRow.filePath;
      const fileName =
        fileRow.fileName ||
        decodeURIComponent(fileUrl.split('/').pop()) ||
        'downloaded_file';

      const params = {
        FileName: fileName,
        Url: fileUrl,
      };

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      );

      const contentType = result?.headers?.['content-type'];
      const blobData = result?.data;

      if (!blobData || !contentType) {
        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
            type: 'error',
          })
        );
        return;
      }

      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(
        showSnackbar({
          message: `"${fileName}" 다운로드 완료`,
          type: 'success',
        })
      );
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  const ResetLogicAll = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    rowClickData.current = '';
    setPreviewUrl(null);
    setPreviewFileName('');
    fileInputRef.current = null;
    prevFilePathRef.current = '';
    prevVideoPathRef.current = '';
    setVideoFile(null);
    setVideoUrl(null);
    setVideoFileName('');
    setDepartmentList([]);
    setSelectedBonbu([]);
    setSelectedBuseo([]);
    setSelectedTeam([]);
    setSelectedPart([]);
    setBonbuList([]);
    setBuseoList([]);
    setTeamList([]);
    setPartList([]);
  };

  //#endregion

  return (
    <div className="wrap">
      <TRA_NEW_04
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        showSnackbar={showSnackbar}
        dispatch={dispatch}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalType={modalType}
        fileList={fileList}
        modalToggle2={modalToggle2}
        setModalToggle2={setModalToggle2}
        modalToggle3={modalToggle3}
        setModalToggle3={setModalToggle3}
        searchRef={props.searchRef}
        filterClick4={props.filterClick4}
        setFilterClick4={props.setFilterClick4}
        searchClick4={props.searchClick4}
        setSearchClick4={props.setSearchClick4}
        addClick4={props.addClick4}
        setAddClick4={props.setAddClick4}
        saveClick4={props.saveClick4}
        setSaveClick4={props.setSaveClick4}
        printClick4={props.printClick4}
        setPrintClick4={props.setPrintClick4}
        fileInputRef={fileInputRef}
        PopupClickEvent1={PopupClickEvent1}
        PopupClickEvent2={PopupClickEvent2}
        rowClickData={rowClickData}
        open={modalToggle2}
        setOpen={setModalToggle2}
        videoFile={videoFile}
        setVideoFile={setVideoFile}
        videoFileName={videoFileName}
        setVideoFileName={setVideoFileName}
        videoUrl={videoUrl}
        setVideoUrl={setVideoUrl}
        previewUrl={previewUrl}
        setPreviewUrl={setPreviewUrl}
        previewFileName={previewFileName}
        setPreviewFileName={setPreviewFileName}
        bonbuList={bonbuList}
        setBonbuList={setBonbuList}
        selectedBonbu={selectedBonbu}
        setSelectedBonbu={setSelectedBonbu}
        buseoList={buseoList}
        setBuseoList={setBuseoList}
        selectedBuseo={selectedBuseo}
        setSelectedBuseo={setSelectedBuseo}
        teamList={teamList}
        setTeamList={setTeamList}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        partList={partList}
        setPartList={setPartList}
        selectedPart={selectedPart}
        setSelectedPart={setSelectedPart}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogicAll={ResetLogicAll}
        SearchLogic1={Search1}
        SaveLogic2={SaveLogic2}
        SaveLogic3={SaveLogic3}
        PrintLogic1={PrintLogic1}
        handleSave={handleSave}
        fetchDepartmentData={fetchDepartmentData}
        getExtension={getExtension}
        renderPreview={renderPreview}
        handleVideoChange={handleVideoChange}
        handleEduFileChange={handleEduFileChange}
        handleFileRowClick={handleFileRowClick}
        handleFileListDelete={handleFileListDelete}
        handleFileListDeleteConfirm={handleFileListDeleteConfirm}
        handleFileListDownload={handleFileListDownload}
        deleteConfirmOpen={deleteConfirmOpen}
        setDeleteConfirmOpen={setDeleteConfirmOpen}
        pendingDeleteFile={pendingDeleteFile}
        loadFileList={loadFileList}
        loadInitialFile={loadInitialFile}
        tempFileList3={tempFileList3}
        tempPreviewVideoUrl={tempPreviewVideoUrl}
        handleEduFileChange3={handleEduFileChange3}
        handleVideoChange3={handleVideoChange3}
        handleTempFileRowClick3={handleTempFileRowClick3}
        handleTempFileDelete3={handleTempFileDelete3}
        renderCheckboxList={renderCheckboxList}
        toggleSelection={toggleSelection}
        getFilteredSelectedItems={getFilteredSelectedItems}
        getDepLevel={getDepLevel}
      />
    </div>
  );
}

export default TRA_NEW_04F;
